import React from "react";
import "./About.css";
import { useNavigate } from "react-router-dom";

import {
  FaGraduationCap,
  FaCode,
  FaPython,
  FaLaptopCode,
  FaArrowRight,
} from "react-icons/fa";

const About = () => {
  const navigate = useNavigate();

  return (
    <section className="about">

      {/* Heading */}
      <div className="about-heading">
        <p className="section-subtitle">GET TO KNOW ME</p>

        <h2>About Me</h2>

        <div className="heading-line"></div>
      </div>


      {/* Main About Content */}
      <div className="about-content">

        {/* Left Side */}
        <div className="about-text">

          <p className="about-intro">
            Hello! I'm
          </p>

          <h3>
            Yamuna <span>Nagireddy</span>
          </h3>

          <h4>Python Full Stack Developer</h4>

          <p>
            I am a passionate developer interested in building responsive,
            user-friendly and practical web applications. I enjoy turning
            ideas into clean and functional digital experiences using
            modern web technologies.
          </p>

          <p>
            My technical skills include HTML, CSS, JavaScript, React,
            Python, MySQL and Django. I enjoy developing applications,
            working with APIs and creating responsive interfaces.
          </p>


          {/* Button */}
          <button
            className="about-btn"
            onClick={() => navigate("/projects")}
          >
            Explore My Work
            <FaArrowRight />
          </button>

        </div>


        {/* Right Side */}
        <div className="about-highlights">

          {/* Education */}
          <div className="highlight-card">

            <div className="highlight-icon">
              <FaGraduationCap />
            </div>

            <div className="highlight-content">
              <h3>Education</h3>
              <p>B.Tech - ECE</p>
            </div>

          </div>


          {/* Frontend */}
          <div className="highlight-card">

            <div className="highlight-icon">
              <FaCode />
            </div>

            <div className="highlight-content">
              <h3>Frontend</h3>
              <p>React & JavaScript</p>
            </div>

          </div>


          {/* Backend */}
          <div className="highlight-card">

            <div className="highlight-icon">
              <FaPython />
            </div>

            <div className="highlight-content">
              <h3>Backend</h3>
              <p>Python & Django</p>
            </div>

          </div>


          {/* Development */}
          <div className="highlight-card">

            <div className="highlight-icon">
              <FaLaptopCode />
            </div>

            <div className="highlight-content">
              <h3>Development</h3>
              <p>Full Stack Projects</p>
            </div>

          </div>

        </div>

      </div>


      {/* Statistics */}
      <div className="about-stats">

        <div className="stat">
          <h3>10+</h3>
          <p>Projects</p>
        </div>

        <div className="stat">
          <h3>3+</h3>
          <p>Internships</p>
        </div>

        <div className="stat">
          <h3>8+</h3>
          <p>Technologies</p>
        </div>

      </div>

    </section>
  );
};

export default About;